import defaultTheme from "./default";
import customTheme from "./custom";

interface ThemeConfigTypes {
  topbar: string;
  sidebar: string;
  layout: string;
  theme: string;
}

const themes = {
  defaultTheme,
  customTheme,
};

export const themeConfig: ThemeConfigTypes = {
  topbar: "defaultTheme",
  sidebar: "defaultTheme",
  layout: "defaultTheme",
  theme: "defaultTheme",
};
export default themes;
